<template>
  <v-container
    v-if="shop.livemode"
    :class="container.class || 'd-flex flex-row flex-wrap justify-space-around'"
  >
    <component
      :is="small ? 'CardSmall' : 'CardLarge'"
      v-for="product in products"
      :key="product.id"
      :card="card"
      :product="product"
      :options="options"
      :class="container.class || 'd-flex flex-row flex-wrap'"
      @openInspect="openInspect"
    />

    <inspect
      :product-id="inspectProductID"
      :options="options"
      @close="inspectProductID=null"
    />
  </v-container>
</template>

<script>
import Inspect from './product/Index'
import CardLarge from './product/card/Large'
import CardSmall from './product/card/Small'

export default {
  components:{
    Inspect,
    CardLarge,
    CardSmall
  },
  props: {
    tags: {
      type: Array,
      default: ()=>null
    },
    options: {
      type: Object,
      default: ()=>{return {}}
    },
    small: {
      type: Boolean
    }
  },
  data(){
    return {
      inspectProductID: null,
      shop: {},
      products: []
    }
  },
  computed: {
    container(){return (this.options||{}).container || {}},
    card(){return (this.options||{}).card || {}},
    prodHints(){return this.$store.getters['market/productHints']}
  },
  watch: {
    tags() {
      this.fetch()
    }
  },
  mounted(){this.fetch()},
  methods: {
    async fetch(){
      this.shop = await this.api.get('/shop/status')
      if(!this.tags){
        this.products = await this.api.get('/product/shop')
      } else {
        this.products = await this.api.get(`/product/shop?tags=${this.tags}`)
      }
    },
    openInspect(productID){
      this.inspectProductID = productID
    }
  }
}
</script>